export const USER_LOCATION_LOCAL_STORAGE = 'vwca-user-location';